import { CampaignLimits } from '../core/data/campaign-limits';
import { MakePaymentModalResultEnum } from './make-payment-modal-result-type';

export class MakePaymentModalResult {
    public campaignLimits: CampaignLimits | null;
    public result: MakePaymentModalResultEnum;
    public newIdempotentKey: string;

    constructor(campaignLimits: CampaignLimits | null, result: MakePaymentModalResultEnum) {
        this.campaignLimits = campaignLimits;
        this.result = result;
    }
}
